import React, { useState, useEffect } from 'react';
import { Button, Input, Modal, Radio, Select, DatePicker } from 'antd';
import dayjs from 'dayjs';
function CreateInventoryModal({
  visible,
  setVisible,
  cancel,
  confirm,
  countSheetDetails,
  createInventory,
  openInventoryTab
}) {

  // const [inventoryDate, setInventoryDate] = useState(dayjs());

  // useEffect(() => {
  //   if (visible) {
  //     setInventoryName('')
  //   }
  // }, [visible])
  return (
    <Modal
      title={countSheetDetails}
      open={visible}
      onCancel={() => setVisible(false)}
      closable
      width={400}
      footer={[
        <Button
          key="cancel"
          className='Deactivate-Button'
          onClick={() => { cancel(null); setVisible(false) }}
        >
          Cancel
        </Button>,
        <Button
          key="add"
          onClick={() => { confirm() }}
          className='printButton2'
        // disabled={inventoryDate === ''}
        >
          Confirm
        </Button>
      ]}
    >
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <span>
          Can you confirm that you have selected the correct date?
        </span>

      </div>

    </Modal>
  )
}

export default CreateInventoryModal
